import { compact, identity, map } from 'lodash/fp';

import { SCALE_LABEL } from '../../ahm-constants/ui';
import { SCALE_OPTIONS } from '../../models/customer/constants';

type GetScaleOptionsProps = {
  format?: (value: string) => string;
  endText?: string;
};

const getScaleOptions = ({ format = identity, endText }: GetScaleOptionsProps = {}) =>
  map(
    (scale) => ({
      text: compact([format(SCALE_LABEL[scale]), endText]).join(` `),
      value: scale,
    }),
    SCALE_OPTIONS,
  );

export default getScaleOptions;
